<div class="closed-modal">
  <div class="closed-modal__backdrop" (click)="closeModal()"></div>
  <div class="closed-modal__container" [class.noLocationAddress]="!isLocationAddress">
    <img
      [class.noAddressMiniLogo]="!isLocationAddress"
      [src]="restaurantModalSign"
      [hidden]="isHideSigns"
      class="closed-modal__closed-sign"
      alt="restaurant closed sign"/>
    <svg
      class="closed-modal__container--close-button"
      aria-label="Close"
      (click)="closeModal()"
    >
      <use xlink:href="./assets/images/icons-sprite.svg#icon-close"></use>
    </svg>
    <div class="closed-modal__container--content">
      <ng-template [ngIf]="storeOrderingPaused">
        <div class="closed-modal__container--title">
          Ordering Paused
        </div>

        <div class="closed-modal__container--text">
          Online ordering is temporarily unavailable. Please contact the merchant{{getPhoneIfExists}}.
        </div>
      </ng-template>
      <ng-template [ngIf]="storeOrderingScheduled">
        <div class="closed-modal__container--title">
          Scheduled Orders
        </div>

        <div class="closed-modal__container--text">
          This store is accepting scheduled orders. To get started, click “Schedule an Order” below.
        </div>
      </ng-template>
      <ng-template [ngIf]="storeClosed">
        <div class="closed-modal__container--title">
          Store Closed
        </div>

        <div class="closed-modal__container--text">
          Online ordering is temporarily closed. Please come back during normal business hours.
        </div>
      </ng-template>
      <div class="closed-modal__restaurants" *ngIf="isGroup">
        <div class="closed-modal__restaurants-chosen"(click)="showRestaurantList()">
          {{restaurant.name}}
          <img class="closed-modal__restaurants-chosen-arrow" [src]="'./assets/images/dropdown-arrow.svg'" alt="dropdown"/>
        </div>
      </div>
      <div class="restaurants-popup" *ngIf="isGroup && isShowRestaurantList">
        <div class="restaurant-list">
          <div class="restaurant-list__restaurant" *ngFor="let restaurant of restaurants; let i = index" (click)="chooseRestaurant(i)">
            {{restaurant.name}}
          </div>
          <hr>
        </div>
      </div>
      <div class="restaurant-work-wrap">
        <div class="hours-wrap"
             [class.fullHours]="!isLocationAddress"
             *ngIf="restaurant.isMobileEnabled && restaurant.isShowHours">
          <div class="day-info" *ngFor="let day of restaurantWorkDays; let i = index">
            <span class="day-info-days">{{day | titlecase}}</span>
            <span class="day-info-hours">{{restaurantWorkHours[i]}}</span>
          </div>
        </div>
        <div class="map-wrap" *ngIf="isLocationAddress">
          <google-map width="100%" height="100%" [center]="center" [zoom]="zoom" [options]="mapOptions">
            <map-marker [position]="userPosition"></map-marker>
          </google-map>
        </div>
      </div>
    </div>
    <div class="closed-modal__container--footer">
      <button class="closed-modal__container--footer-button closed-modal__container--footer-button-gray" (click)="goToHomePage()" *ngIf="isMultipleLocations">
        Back to locations
      </button>
      <button class="closed-modal__container--footer-button" (click)="closeModal()">
        {{ storeOrderingScheduled ? "Schedule an order" : "See menu" }}
      </button>
    </div>
  </div>
</div>
